 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML01_HALFTITLE from '@/components/xhtml/01_Halftitle'
 import XHTML02_TITLE from '@/components/xhtml/02_Title'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML05_ILLUSTRATIONS from '@/components/xhtml/05_Illustrations'
 import XHTML06_MAPS from '@/components/xhtml/06_Maps'
 import XHTML07_MAP1 from '@/components/xhtml/07_Map1'
 import XHTML08_MAP2 from '@/components/xhtml/08_Map2'
 import XHTML09_MAP3 from '@/components/xhtml/09_Map3'
 import XHTML10_MAP4 from '@/components/xhtml/10_Map4'
 import XHTML11_MAP5 from '@/components/xhtml/11_Map5'
 import XHTML12_MAP6 from '@/components/xhtml/12_Map6'
 import XHTML13_MAP7 from '@/components/xhtml/13_Map7'
 import XHTML14_MAP8 from '@/components/xhtml/14_Map8'
 import XHTML15_ACKNOWLEDGEMENTS from '@/components/xhtml/15_Acknowledgements'
 import XHTML16_PROLOGUE from '@/components/xhtml/16_Prologue'
 import XHTML17_CHAPTER_1 from '@/components/xhtml/17_Chapter_1'
 import XHTML18_CHAPTER_2 from '@/components/xhtml/18_Chapter_2'
 import XHTML19_CHAPTER_3 from '@/components/xhtml/19_Chapter_3'
 import XHTML20_CHAPTER_4 from '@/components/xhtml/20_Chapter_4'
 import XHTML21_CHAPTER_5 from '@/components/xhtml/21_Chapter_5'
 import XHTML22_CHAPTER_6 from '@/components/xhtml/22_Chapter_6'
 import XHTML23_CHAPTER_7 from '@/components/xhtml/23_Chapter_7'
 import XHTML24_CHAPTER_8 from '@/components/xhtml/24_Chapter_8'
 import XHTML25_CHAPTER_9 from '@/components/xhtml/25_Chapter_9'
 import XHTML26_CHAPTER_10 from '@/components/xhtml/26_Chapter_10'
 import XHTML27_CHAPTER_11 from '@/components/xhtml/27_Chapter_11'
 import XHTML28_CHAPTER_12 from '@/components/xhtml/28_Chapter_12'
 import XHTML29_TAIL from '@/components/xhtml/29_Tail'
 import XHTML30_APPENDIX_A from '@/components/xhtml/30_Appendix_A'
 import XHTML31_APPENDIX_B from '@/components/xhtml/31_Appendix_B'
 import XHTML32_APPENDIX_C from '@/components/xhtml/32_Appendix_C'
 import XHTML33_ENDNOTES from '@/components/xhtml/33_Endnotes'
 import XHTML34_BIBLIOGRAPHY from '@/components/xhtml/34_Bibliography'
 import XHTML35_GLOSSARY from '@/components/xhtml/35_Glossary'
 import XHTML36_CONTRIBUTORS from '@/components/xhtml/36_Contributors'
 import XHTML37_PLATES from '@/components/xhtml/37_Plates'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/05_Illustrations",
 			"name" : "xhtml/05_Illustrations",
 			"component" : XHTML05_ILLUSTRATIONS
 		},
 		{
 			"path" : "/xhtml/06_Maps",
 			"name" : "xhtml/06_Maps",
 			"component" : XHTML06_MAPS
 		},
 		{
 			"path" : "/xhtml/07_Map1",
 			"name" : "xhtml/07_Map1",
 			"component" : XHTML07_MAP1
 		},
 		{
 			"path" : "/xhtml/08_Map2",
 			"name" : "xhtml/08_Map2",
 			"component" : XHTML08_MAP2
 		},
 		{
 			"path" : "/xhtml/09_Map3",
 			"name" : "xhtml/09_Map3",
 			"component" : XHTML09_MAP3
 		},
 		{
 			"path" : "/xhtml/10_Map4",
 			"name" : "xhtml/10_Map4",
 			"component" : XHTML10_MAP4
 		},
 		{
 			"path" : "/xhtml/11_Map5",
 			"name" : "xhtml/11_Map5",
 			"component" : XHTML11_MAP5
 		},
 		{
 			"path" : "/xhtml/12_Map6",
 			"name" : "xhtml/12_Map6",
 			"component" : XHTML12_MAP6
 		},
 		{
 			"path" : "/xhtml/13_Map7",
 			"name" : "xhtml/13_Map7",
 			"component" : XHTML13_MAP7
 		},
 		{
 			"path" : "/xhtml/14_Map8",
 			"name" : "xhtml/14_Map8",
 			"component" : XHTML14_MAP8
 		},
 		{
 			"path" : "/xhtml/15_Acknowledgements",
 			"name" : "xhtml/15_Acknowledgements",
 			"component" : XHTML15_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/16_Prologue",
 			"name" : "xhtml/16_Prologue",
 			"component" : XHTML16_PROLOGUE
 		},
 		{
 			"path" : "/xhtml/17_Chapter_1",
 			"name" : "xhtml/17_Chapter_1",
 			"component" : XHTML17_CHAPTER_1
 		},
 		{
 			"path" : "/xhtml/18_Chapter_2",
 			"name" : "xhtml/18_Chapter_2",
 			"component" : XHTML18_CHAPTER_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js